<template>
    <modal
        :id="modalId"
        v-model="modalShow"
        title="What would you like to do?"
        scrollable
        size="lg"
        @hide="hideModal"
    >
        <div class="text-content">
            {{ textContent }}
        </div>
        <template v-slot:modal-footer>
            <b-button
                variant="primary"
                @click="answer(1)"
            >Proceed</b-button>
            <b-button
                v-if="associate"
                variant="primary"
                @click="answer(2)"
            >New reservations only</b-button>
            <b-button
                v-if="associate"
                variant="primary"
                @click="answer(3)"
            >I'll assign reservations manually</b-button>
            <b-button
                v-if="!associate"
                variant="primary"
                @click="answer(2)"
            >Leave reservations unassigned</b-button>
            <b-button @click="answer(4)">Cancel</b-button>
        </template>
    </modal>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';

export default {
    name: 'SystemEmailEditModal',
    components: {
        Modal,
    },
    props: {
        modalId: String,
        cleaner: String,
        property: String,
        associate: Boolean,
    },
    data() {
        return {
            modalShow: false,
        }
    },
    computed: {
        textContent() {
            if (this.associate) {
                return `Existing reservations / invoices for ${this.property} that are not currently assigned to a housekeeper will now be assigned to ${this.cleaner}. This is recommended as reservations without a housekeeper will not show up in the housekeeping report.`
            }
            return `Reservations / invoices previously assigned to ${this.cleaner} will now be assigned to a different housekeeper. This is recommended as reservations without a housekeeper will not show up in the housekeeping report.`
        }
    },
    methods: {
        hideModal() {
            this.$emit('answer', 4);
            this.$bvModal.hide(this.modalId);
        },
        answer(answer) {
            this.$emit('answer', answer);
            this.$bvModal.hide(this.modalId);
        }
    },
};
</script>
